import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {AuthService} from './auth.service';
import {catchError, map} from 'rxjs/operators';
import {User} from '../models/User';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url: string = state.url;

    return this.isAdmin(url);
  }

  isAdmin(url: string): Observable<boolean> {
    if (this.authService.user) {
      const admin = this.authService.user.roles.indexOf('ADMIN') >= 0;
      if (!admin) {
        this.router.navigate(['']);
      }
      return of(admin);
    }

    return this.authService.retrieveUser().pipe(
      map(
        result => {
          const admin = (<User>result).roles.indexOf('ADMIN') >= 0;
          if (!admin) {
            this.router.navigate(['']);
          }
          return admin;
        }),
      catchError(error => {
        console.log(error);
        this.router.navigate(['']);
        return of(false);
      }));
  }

}
